export function mergeId<Id extends string | number>(prevId: Id | null, nextId: Id | null, nextIds: Id[]): Id | null {
  if (prevId && nextIds.includes(prevId)) {
    return prevId;
  }

  return nextId;
}
